export default {
      id: "profile-star-usage",
      viewBox: "0 0 40.68 60",
      url: "../../assets/" + "sprite.svg#profile-star-usage",
      toString: function () {
        return this.url;
      }
    }